export default class Session {
    #session = {};

    constructor(session) {
        this.#session = session ?? {};
    }

    get(key) {
        return _.get(this.#session, key);
    }
}
